import { Component, Switch, Match } from "solid-js";
import { CheckoutFlowProvider } from "@/contexts/checkout-flow/checkout-flow.provider";
import CheckoutFlow from "@/app/CheckoutFlow/CheckoutFlow";
import { AdminEligibilityModal } from "@/components/modals/admin-eligibility-modal/AdminEligibilityModal";
import { AgreementsModal } from "@/components/modals/agreements-modal/AgreementsModal";
import { ProductEligibilityModal } from "@/components/modals/product-eligibility-modal/ProductEligibilityModal";
import { FsModalDialog } from "@cof/fs-modal-dialog-wc";
import { useEligibilityChecks } from "@/hooks/useEligibilityChecks";
import { CancelCampaignParams, Permission } from "@/Main";
import { MODAL_EXIT_DELAY_MS } from "@/shared/constants/event.const";

interface FeaturedDealerProps {
  dealerId: string;
  userId: string;
  userIsAdmin: boolean;
  featureToggles: Record<string, boolean>;
  cancelCampaign?: CancelCampaignParams;
  exitFeaturedDealer: () => void;
  permissions?: Record<string, Permission>;
}

const FeaturedDealer: Component<FeaturedDealerProps> = (props) => {
  let rootRef: HTMLDivElement | undefined;

  const handleModalClose = (modalRef: FsModalDialog) => {
    modalRef?.closeModalDialog();
  };

  const closeModalAndExitMfe = (modalRef: FsModalDialog) => {
    handleModalClose(modalRef);
    setTimeout(() => {
      props.exitFeaturedDealer();
    }, MODAL_EXIT_DELAY_MS);
  };

  const {
    eligibility,
    adminAccess,
    agreementSigned,
    allChecksPassed,
    shouldShowPlaceholder,
    hasEligibilityErrors,
    isLoadingEligibility,
  } = useEligibilityChecks({
    dealerId: props.dealerId,
    userId: props.userId,
    userIsAdmin: props.userIsAdmin,
    permissions: props.permissions,
  });

  return (
    <div ref={rootRef}>
      <Switch>
        <Match when={adminAccess() === false}>
          <AdminEligibilityModal onClose={closeModalAndExitMfe} />
        </Match>
        <Match when={eligibility() === false}>
          <ProductEligibilityModal onClose={closeModalAndExitMfe} />
        </Match>
        <Match when={agreementSigned() === false}>
          <AgreementsModal
            dealerId={props.dealerId}
            onClose={closeModalAndExitMfe}
          />
        </Match>
      </Switch>
      <CheckoutFlowProvider
        dealerId={props.dealerId}
        featureToggles={props.featureToggles}
        cancelCampaign={props.cancelCampaign}
        exitFeaturedDealer={props.exitFeaturedDealer}
      >
        <CheckoutFlow
          shouldFetchData={allChecksPassed()}
          showPlaceholder={shouldShowPlaceholder()}
          hasEligibilityErrors={hasEligibilityErrors()}
          isLoadingEligibility={isLoadingEligibility()}
        />
      </CheckoutFlowProvider>
    </div>
  );
};

export default FeaturedDealer;
